import React, { ComponentProps } from "react";
import styled from "styled-components";
import { typographyMixin } from "../../helpers";
import { TColor, TTypographyVariant } from "../../types";

const StyledLabel = styled.div<{ size: TTypographyVariant; $color: TColor }>`
    color: ${({ theme, $color }) => theme.v2.colors[$color]};
    ${({ size }) => typographyMixin(size)}
`;

type TOurProps = {
    as?: ComponentProps<typeof StyledLabel>["as"];
    children: React.ReactNode;
    className?: string;
    color?: TColor;
    size?: TTypographyVariant;
    styles?: React.CSSProperties;
};

type TProps = TOurProps & Omit<React.HTMLAttributes<HTMLDivElement>, keyof TOurProps>;

/**
 * @deprecated Use `Typography` for styling text. `Typography` is an inline styling, so update your components accordingly!
 */
const Label = ({
    as,
    children,
    className,
    color = "text-primary-1200",
    size = "label-small-medium",
    styles = {},
    ...props
}: TProps) => (
    <StyledLabel {...props} $color={color} as={as} className={className} size={size} style={styles}>
        {children}
    </StyledLabel>
);

export default Label;
